import {DataGrid} from "@mui/x-data-grid";
//import { GridColDef } from '@mui/x-data-grid';
import { Paper, Typography, Button, FormControl, InputLabel, Select, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import {CSVLink} from "react-csv"
import {useEffect, useState} from "react"
//import { getTours } from "../actions/customer";
//import { useSelector } from "react-redux";
import { fetchSuppliers, fetchSuppliersbyDest2, fetchDest} from "../api/customerapi";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      height: theme.spacing(6),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      justifyContent: "center",
    },
}));

const Suppliertourdata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
//console.log(width);
const columns = [
    {
        field: 'supplier_id',
        headerName: 'Id',
        width: width/12,
        
      },
    { field: 'supplier_name', 
  headerName: ' Name', 
  width: width/12*3,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
    { field: 'supplier_type', 
    headerName: ' Type', 
    width: width/12*2,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
    },
    {
      field: 'supplier_destinations',
      headerName: 'Destinations',
      width: width/12*6,
      
    },
    
  ];

const headers=[
  {label:"Supplier Id", key:"supplier_id"},
  {label:"Name", key:"supplier_name"},
  {label:"Type", key:"supplier_type"},
  {label:"Destinations", key:"supplier_destinations"},
 
]
  
  const [dest, setdest]=useState([])
  const [leadfilterData, setleadfilterData]=useState({})
  const [listsupplierData, setlistsupplierData] =useState([{
    supplier_name: "",
  
    supplier_type: "",
    supplier_destinations: "",
    
    }]);
  
  const loadsuppliers = async () => {
    try{
    if(leadfilterData.destination=="" || leadfilterData.destination==null || leadfilterData.destination=="All" ) {
      
      const data = await fetchSuppliers();
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlistsupplierData(data.data)
      }else{
        const data = await fetchSuppliersbyDest2(leadfilterData.destination);
      //console.log(data);
      //const custdatalistfromdb= data.data
      setlistsupplierData(data.data)
    
      }
    }catch(err){
      console.log(err)
    }
  }

  const getDest = async () => {
    try{
    const data = await fetchDest();
    const temp=data.data.filter(d=>"order" in d)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  }
  
  useEffect(() => {
    getDest()
    
  }, [])

 
  
  
  const supplierdatalistdisplay=listsupplierData.map(sdata=>({supplier_name: sdata.supplier_name, 
    id:listsupplierData.indexOf(sdata),
    supplier_id:sdata.supplier_id, 
    supplier_type:sdata.supplier_type, 
    supplier_destinations:sdata.supplier_destinations }));
  //console.log(custdatalistfromdb);

  const gridcellclick=(id)=>{
    window.location = ("/supplierdataentry/"+id);
    //console.log("/custdataentry/"+id);
  }

    return ( 
      <div>
      {dest.length>0 ?(
        <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View Suppliers</Typography>
        <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Destination">Destination</InputLabel>
                <Select displayEmpty className={classes.textField} InputLabelProps={{ shrink: true }} labelId="Destination" value={leadfilterData.destination} onChange={(e)=> setleadfilterData({...leadfilterData, destination: e.target.value})}>
                
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}  
                
                </Select>
                </FormControl>

        <Button href="/supplierdataentry"  variant="contained" color="secondary" align="center" className={classes.button}>Add Supplier</Button>
        <Button onClick={loadsuppliers} variant="contained"  color="inherit" className={classes.button}>Load</Button>
        </div>
        {supplierdatalistdisplay.length>1?(<div>
                   <CSVLink data={supplierdatalistdisplay} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={supplierdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.supplier_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
    ):("Loading...")}
    </div>
     )
}
 
export default Suppliertourdata;